module.exports = __webpack_public_path__ + "fonts/loleicons.2dc05af.eot";